(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var BaseView = require('cf-base-view')

module.exports = BaseView.extend(
  { tagName: 'article'

  , className: 'js-item list-group-item ec-form-list-group-item'

  , events:
    { 'click .js-edit': 'renderEditModal'
    , 'click .js-delete': 'handleDelete'
    }

  , initialize: function () {
      this.editModal = new this.FormView(
        { title: 'Edit ' + this.options.title
        , model: this.model
        , parentModel: this.options.parentModel
        , collection: this.model.collection
        , serviceLocator: this.options.serviceLocator
        , showRequiredFields: this.options.showRequiredFields
        })

      this.listenTo(this.model, 'change', this.render, this)
      this.render()
    }

  , handleDelete: function () {
      if (this.model.collection) {
        var collection = this.model.collection
        this.model.collection.remove(this.model, { silent: true })
        collection.trigger('change')
        BaseView.prototype.remove.call(this)
      } else if (window.console && window.console.log) {
        console.log('DEBUG:sub-list-item:33: this.model.collection not defined')
      }
    }

  , renderEditModal: function () {
      this.editModal.render()
    }

  , render: function () {
      this.$el.html(this.template(
        { data: this.model.toJSON()
        , lists: this.options.serviceLocator.lists
        }
      ))
    }
  }
)

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/generic/sub-list-item.js","/admin/source/js/app/lib/generic")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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